const Home = () => import('@/views/pdd/home') // 首页
const Search = () => import('@/views/pdd/search') // 搜索
const Mine = () => import('@/views/pdd/mine') // 我的

export default [
  { path: '/pdd', name: 'pddHome', component: Home, meta: { isTab: false, keepAlive: true, title: '拼多多' } },
  { path: '/pdd/search', name: 'pddSearch', component: Search, meta: { isTab: false, keepAlive: true, title: '搜索' } },
  { path: '/pdd/mine', name: 'pddMine', component: Mine, meta: { isTab: false, keepAlive: true, requireAuth: false, title: '我的' } },
]